// material-ui

import insertterminalicon from '../../../assets/images/insert-terminal.svg';
/**
 * if you want to use image instead of <svg> uncomment following.
 *
 * import logoDark from 'assets/images/logo-dark.svg';
 * import logo from 'assets/images/logo.svg';
 *
 */

// ==============================|| LOGO SVG ||============================== //

const InsertTerminalIcon = () => {
    

    return (
        /**
         * if you want to use image instead of svg uncomment following, and comment out <svg> element.
         *
         * <img src={logo} alt="Berry" width="100" />
         *
         */
         <img src={insertterminalicon} alt="Insert Terminal" width="22"  />
    );
};

export default InsertTerminalIcon;